export enum UserDefaultState {
  'home' = 0,
  'dashboard' = 1,
  'charts' = -2,
  'map' = -1,
  'eventslog' = -4,
}

